export default  {
    catalogue: [],
    renseignements:[]
}